import { render } from "./SuccessPage.vue?vue&type=template&id=208a622c&scoped=true&ts=true"
import script from "./SuccessPage.vue?vue&type=script&lang=ts"
export * from "./SuccessPage.vue?vue&type=script&lang=ts"

import "./SuccessPage.vue?vue&type=style&index=0&id=208a622c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208a622c"]])

export default __exports__